import React from 'react'
import Logo from '../../components/Logo'
import TitleBarButton from '../../components/TitleBarButton'
import DateTime from '../../components/DateTime'
import { connect } from 'react-redux';
import * as general from '../../constants/General'
import * as resource from '../../constants/Resources'
import { getTranslation } from '../../actions/dataActions'
import PropTypes from 'prop-types'
import ClickNHold from 'react-click-n-hold'
import { toggleKeyboard } from '../../actions/layoutActions'
import { logoutUser } from '../../actions/loginActions'
import { setMessageModal } from '../../actions/generalActions'
import { closeReceiptAndLogOut } from '../../actions/receiptActions'

class TitleBar extends React.Component {
  constructor(props){
    super(props);
    this.showKeyboard = this.showKeyboard.bind(this);
    this.logout = this.logout.bind(this);
  }

  logout() {
    if (this.props.receiptnumber === undefined || !this.props.receiptnumber) {
        this.props.logoutUser();
        this.props.toggleKeyboard(false);
      } else if (this.props.objectitemid) {
        this.props.closeReceiptAndLogOut();
      } else {
        this.props.setMessageModal(true, this.props.getTranslation(resource.RECEIPT_IS_OPEN));
      }
  }

  showKeyboard(e, enough) {
    if(enough) {
      this.props.toggleKeyboard(true, '#hfKeyboardInfo', this.props.getTranslation(resource.PASSWORD), this.logout, [], false);
    }
  }

  render() {
    let userHTML = '';
    let showhideReceipt = '';

    if (this.props.user !== undefined) {
      if (this.props.user.username !== undefined) {
        userHTML = (
          <div className="titlebar-info">
            <i className="user icon">&nbsp;</i>
            {this.props.user.username}
          </div>
        )

        showhideReceipt = (
          <div className="titlebar-showhidereceipt">
            <TitleBarButton
              text=""
              icon="content icon"
              type={general.TITLEBAR_SHOWHIDERECEIPT}
            />
          </div>
        )
      }
    }
    return (
      <div id="titlebar">
        <Logo />
        {showhideReceipt}
        <div className="titlebar-right" style={{marginRight: 0}}>
          <div className="titlebar-datetime">
            <DateTime />
          </div>
          <ClickNHold
              time={4}
              onEnd={this.showKeyboard} >
              {userHTML}
          </ClickNHold>
          <div id="hfKeyboardInfo" type="password" placeholder={this.props.getTranslation(resource.PASSWORD)} style={{display: 'none'}}></div>
        </div>
      </div>)
  }
}

TitleBar.propTypes = {
  user: PropTypes.object,
  toggleKeyboard: PropTypes.func.isRequired,
  setMessageModal: PropTypes.func.isRequired,
  receiptnumber: PropTypes.number,
  logoutUser: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    user: state.loginState.loggedin,
    receiptnumber: state.receiptState.receipt.receiptnumber,
  }
}

export default connect(mapStateToProps,
  {
    getTranslation,
    toggleKeyboard,
    logoutUser,
    setMessageModal,
    closeReceiptAndLogOut
  })(TitleBar)



// WEBPACK FOOTER //
// src/kiosk/components/TitleBar.jsx